import api from '@/api'
export default {
  // get Influencer Wordcloud for Admin
  createCampaignPayout(campaignPayout) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/payments-open/campaignPayout/', true, campaignPayout)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Influencer/paymentAPIs.js